import { styled as e, Box as i } from "@mui/material";
import { SkeletonTypography as o } from "../../temp-lib/components/share/generic/Skeleton.js";
import a from "../../temp-lib/components/share/next/Image.js";
import { DEFAULT_ALT as m } from "../../temp-lib/constants/layout.js";
import { jsxs as n, jsx as t } from "react/jsx-runtime";
const x = e(i)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 20px;
`, f = e(a)`
  aspect-ratio: 1;
  width: 34px;
`, h = e(i)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-end;
`, d = e(o)`
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
`, g = e(o)`
  color: #b1b3b3;
  font-size: 14px;
  font-weight: 300;
  line-height: 14px;
`, j = (r) => {
  const {
    amount: c,
    className: s,
    iconUrl: l,
    unit: p
  } = r;
  return /* @__PURE__ */ n(x, {
    className: s,
    children: [/* @__PURE__ */ t(f, {
      src: l,
      alt: m
    }), /* @__PURE__ */ n(h, {
      children: [/* @__PURE__ */ t(d, {
        children: c
      }), /* @__PURE__ */ t(g, {
        children: p
      })]
    })]
  });
};
export {
  j as default
};
//# sourceMappingURL=Token.js.map
